import { makeStyles } from '@material-ui/core';
import { SizeType } from 'src/common/enumerations/cashier-preference-level';
import CashierPreferencesHelper from 'src/common/helpers/cashier-preferences-helper';
import { hSpacing, vSpacing } from 'src/common/helpers/config';
import { px, rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';
interface MenuButtonStyleProps {
  textSize: SizeType;
  leftHanded: boolean;
  trainingModeActive: boolean;
}

// Until the theme gets typed...
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const styles = makeStyles((theme: any) => {
  return {
    menuButtonWrapper: ({ trainingModeActive }: MenuButtonStyleProps) => ({
      position: 'relative',
      margin: `0 0 0 -${hSpacing}`,
      '&:before': {
        content: '""',
        position: 'absolute',
        top: `-${vSpacing}`,
        left: 0,
        height: `calc(100% + ${vSpacing})`,
        width: hSpacing,
        background: trainingModeActive
          ? themeColor.trainingColor
          : theme?.configColors?.secondaryColor || theme.palette.secondary.main,
      },
    }),
    menuButton: {
      width: '100%',
      padding: `${vSpacing} ${hSpacing}`,
      paddingLeft: '1.6vw',
      minWidth: '64px',
      backgroundColor: 'transparent',
      boxShadow: 'none !important',
      fontSize: px(16),
      justifyContent: 'flex-start',
      '&:hover': {
        background: 'none',
      },
    },
    iconStyle: ({ textSize }: MenuButtonStyleProps) => ({
      color: theme.infoMain,
      '&.icon': {
        height: CashierPreferencesHelper.sizeMultiplier(textSize) * 22,
        width: CashierPreferencesHelper.sizeMultiplier(textSize) * 22,
        '@media (min-width: 960px)': {
          width: rem(1.5),
          height: rem(1.5),
        },
        '@media (min-width: 1024px)': {
          width: rem(1.5),
          height: rem(1.5),
        },
        '@media (min-width: 1366px)': {
          width: rem(1.75),
          height: rem(1.75),
        },
        '@media (min-width: 1600px)': {
          width: rem(2),
          height: rem(2),
        },
      },
    }),
    labelStyle: {
      color: theme.defaultTextColor,
      marginLeft: hSpacing,
      lineHeight: '2.08vh',
      letterSpacing: '0.09vw',
      '& svg': {
        marginTop: '-5%',
        maxWidth: '4vw',
      },
    },
  };
});
